import { ResponseType } from '../types/shared.types';
import {
  GetMerchantReferralsParams,
  GetRestaurantReferralsParams,
  LocationReferralSummary,
  MerchantReferralListResponse,
  RestaurantReferral,
  RestaurantReferralListResponse,
} from '../types/restaurantReferral.types';
import { api } from './api';

/**
 * Restaurant-to-restaurant referrals. See `types/restaurantReferral.types` for
 * the program. Both apps call `/v1/referrals`, and get different answers: the
 * admin API lists the whole program, the customer API one location's invites.
 */

export const RESTAURANT_REFERRALS_PAGE_SIZE = 20;

/* --------------------------------- admin --------------------------------- */

/** Admin and support. Newest first. */
export const getRestaurantReferrals = (params: GetRestaurantReferralsParams) =>
  api.get<ResponseType<RestaurantReferralListResponse>>('/v1/referrals', {
    params,
  });

/** 404 for one that does not exist or that the program does not count. */
export const getRestaurantReferral = (referralId: number | string) =>
  api.get<ResponseType<RestaurantReferral>>(`/v1/referrals/${referralId}`);

/**
 * Who brought a location in, and how many it brought in itself.
 *
 * Only `GET /v2/locations/:id` carries these two fields; the Location Details
 * page is built from the v1 answer, which has everything else and not these.
 * Typed down to the two fields because that is all that is read.
 */
export const getLocationReferralSummary = (locationId: number | string) =>
  api.get<ResponseType<LocationReferralSummary>>(`/v2/locations/${locationId}`);

/* -------------------------------- merchant ------------------------------- */

/** Partner and manager, members of `locationId` only. */
export const getMerchantReferrals = (params: GetMerchantReferralsParams) =>
  api.get<ResponseType<MerchantReferralListResponse>>('/v1/referrals', {
    params,
  });
